import React from 'react';
import { ArrowLeft } from 'lucide-react';
import Logo from '../Logo';
import { Card } from '../ui/card';
import { Button } from '../ui/button';
import './authTheme.css';

export function AuthSurface({ children }) {
  return (
    <div className="lexa-auth-surface min-h-screen bg-[#faf9f6] text-slate-950 flex items-center justify-center px-4 py-8 sm:p-8">
      {children}
    </div>
  );
}

export function AuthCard({ children }) {
  return (
    <Card className="rounded-2xl border border-slate-200 bg-white p-6 sm:p-8 shadow-none">
      {children}
    </Card>
  );
}

export function AuthBrandHeader({ onBack }) {
  return (
    <div className="flex items-center gap-3 mb-8">
      <Button variant="ghost" size="sm" onClick={onBack} aria-label="Back to home" className="p-2">
        <ArrowLeft className="h-4 w-4" aria-hidden="true" />
      </Button>
      <Logo size="md" />
    </div>
  );
}

export function AuthHeading({ title, description }) {
  return (
    <div className="text-center mb-8">
      <h2 className="text-3xl font-semibold tracking-tight text-slate-950 mb-2">{title}</h2>
      <p className="text-slate-500">{description}</p>
    </div>
  );
}
